import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { NitroIcon, NitroText } from 'nitro-components';

import { media } from 'style-utils';
import FormattedMetric from './FormattedMetric';
import Breakpoint from '../../../utils/breakpoints';
import { KEY_UNDERS } from '../const';

const MobileInsightsUtilisation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 40px auto;
  color: ${props => props.theme.color.negative};
  font-size: 25px;
  margin-bottom: 10px;
`;

const UtilisationDescription = styled.div`
  font-size: 48px;
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  color: ${props => props.theme.color.negative};
  text-align: center;
  font-weight: normal;
  top: 100px;

  ${media.mobileTablet`
    margin: 10px 0;
  `};
`;

const UtilisationKeyMetricContainer = styled.div`
  display: -ms-flex;
  display: -webkit-flex;
  display: flex;
  position: absolute;
  bottom: 0;
  height: 44px;
  width: 100%;
  & > div {
    width: 50%;
  }
`;

const UtlisationKeyMetricContent = styled.div`
  padding-top: 4%;
  padding-bottom: 4%;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  vertical-align: middle;
  color: ${props => props.theme.color.white};
  background-color: ${props =>
    (KEY_UNDERS.indexOf(props.type)>-1)
      ? props.theme.color.under
      : props.theme.color.negative};
`;

const KeyMetrics = ({ values }) => (
  <UtilisationKeyMetricContainer>
    {values.map((valueObj, index) => {
      const description = valueObj.Description;
      const value = valueObj.Value;
      return (
        <UtlisationKeyMetricContent type={description} key={index}>
          <NitroIcon
            right={3}
            name={
               (KEY_UNDERS.indexOf(description)>-1)
                ? 'solid-yellow-warning'
                : 'solid-red-warning'
            }
            size={24}
          />
          <NitroText bold size={13}>
            {value}{' '}
          </NitroText>
          <NitroText size={13}>{description}</NitroText>
        </UtlisationKeyMetricContent>
      );
    })}
  </UtilisationKeyMetricContainer>
);

const InsightUtilisation = ({ description, dataType, metric, values }) => (
  <div>
    <Breakpoint name="tabletDesktop">
    
      <UtilisationDescription title={description}>
      {values.length>0 ? 
        <FormattedMetric value={metric} dataType={dataType} />
      : <NitroText size={13}>{description}</NitroText>}
      </UtilisationDescription>
      <KeyMetrics values={values} />
    </Breakpoint>

    <Breakpoint name="mobile">
      <MobileInsightsUtilisation>
        <FormattedMetric value={metric} dataType={dataType} />
      </MobileInsightsUtilisation>
     
    </Breakpoint>
  </div>
);

InsightUtilisation.propTypes = {
  metric: PropTypes.number,
  values: PropTypes.array,
  dataType: PropTypes.string,
  description: PropTypes.string,
};

export default InsightUtilisation;



// WEBPACK FOOTER //
// ./src/features/insights/components/InsightUtilisation.js